import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'; // <-- Import hook
import './PwaInstallPrompt.css'; // We will create this for styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faTimes } from '@fortawesome/free-solid-svg-icons';

const PwaInstallPrompt = () => {
    const { t } = useTranslation(); // <-- Use hook
    const [installPromptEvent, setInstallPromptEvent] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleBeforeInstallPrompt = (event) => {
            // Prevent the mini-infobar from appearing on mobile
            event.preventDefault();
            // Stash the event so it can be triggered later.
            setInstallPromptEvent(event);
            // Show our custom install prompt
            setIsVisible(true);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = () => {
        if (!installPromptEvent) {
            return;
        }
        // Show the browser's install prompt
        installPromptEvent.prompt();
        // Wait for the user to respond to the prompt
        installPromptEvent.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
                console.log('User accepted the PWA installation');
            } else {
                console.log('User dismissed the PWA installation');
            }
            // We can only use the prompt once, so clear it.
            setInstallPromptEvent(null);
            setIsVisible(false);
        });
    };

    const handleDismissClick = () => {
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className="pwa-install-prompt">
            <div className="pwa-prompt-content">
                  <p>{t('pwa_prompt_text')}</p>
                <button className="install-button" onClick={handleInstallClick}>
                    <FontAwesomeIcon icon={faDownload} /> Install
                </button>
            </div>
            <button className="dismiss-button" onClick={handleDismissClick}>
                <FontAwesomeIcon icon={faTimes} />
            </button>
        </div>
    );
};

export default PwaInstallPrompt;